import { Box, Stack, SxProps, Typography, useTheme } from "@mui/material";
import React from "react";
import BybHr from "../byb-hr";

interface IBybSectionProps {
  title?: string;
  children?: React.ReactNode;
  valueHeader?: string | React.ReactNode;
  divider?: boolean;
  stickyHeader?: boolean;
  noHeaderPadding?: boolean;
  tight?: boolean;
  sx?: SxProps;
  className?: string;
}

const BybSection = ({
  title,
  children,
  valueHeader,
  divider,
  stickyHeader,
  noHeaderPadding = false,
  tight = false,
  sx,
  className,
}: IBybSectionProps) => {
  const theme = useTheme();
  return (
    <Box
      className={className}
      sx={{
        backgroundColor: theme.palette.dsBase.v100,
        position: "relative",
        ...sx,
      }}
    >
      {title && (
        <Box
          sx={{
            position: stickyHeader ? "sticky" : "relative",
            top: stickyHeader ? 0 : undefined,
            zIndex: 1,
            borderRadius: "inherit",
            backgroundColor: "inherit",
          }}
        >
          <Stack
            direction="row"
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              ...(!noHeaderPadding && {
                paddingX: theme.spacing(2.5),
                paddingTop: theme.spacing(tight ? 1.5 : 3),
              }),
            }}
          >
            <Typography variant="textS600" color={theme.palette.dsNeutral.v400}>
              {title}
            </Typography>
            {valueHeader &&
              (typeof valueHeader === "string" ? (
                <Typography variant="textS600" color={theme.palette.dsNeutral.v400}>
                  {valueHeader}
                </Typography>
              ) : (
                valueHeader
              ))}
          </Stack>
          {divider && <BybHr sx={{ marginTop: theme.spacing(2) }} />}
        </Box>
      )}
      {children}
    </Box>
  );
};

export default BybSection;
